import { Dialog } from 'primereact/dialog';
import { FormEvent, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { routes } from '@/config/routes';

type SearchOverlayProps = {
  visible: boolean;
  onHide: () => void;
};

export function SearchOverlay({ visible, onHide }: SearchOverlayProps) {
  const [query, setQuery] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (visible) window.setTimeout(() => inputRef.current?.focus(), 0);
  }, [visible]);

  function submit(event: FormEvent) {
    event.preventDefault();
    const normalized = query.trim();
    navigate(`${routes.search}?q=${encodeURIComponent(normalized)}`);
    onHide();
  }

  return (
    <Dialog
      className="search-dialog"
      header="Find something meaningful"
      visible={visible}
      onHide={onHide}
      dismissableMask
      draggable={false}
      aria-label="Search products"
    >
      <form className="search-overlay-form" role="search" onSubmit={submit}>
        <label htmlFor="global-search">Search products</label>
        <div className="search-overlay-form__row">
          <span className="p-input-icon-left">
            <i className="pi pi-search" aria-hidden="true" />
            <input
              className="p-inputtext p-component"
              id="global-search"
              ref={inputRef}
              value={query}
              onChange={(event) => setQuery(event.target.value)}
              placeholder="Try “family”, “wedding”, or “photo”"
            />
          </span>
          <button className="p-button p-component" type="submit">
            Search
          </button>
        </div>
        <p>
          Full-text search is being upgraded. Your query will open a page with live category and
          filter alternatives.
        </p>
      </form>
    </Dialog>
  );
}
